export default __webpack_public_path__ + "static/media/games.70033baf.webp";